// extracted by mini-css-extract-plugin
export default {"root":"instruction_root__TBii+","title":"instruction_title__b7Sg+"};